import type { Ref } from "react";
import { BasilMenu } from "@/components/icons/basil";
import { BrandWordmark } from "@/components/layout/BrandWordmark";
import { HudChips } from "@/components/layout/HudChips";
import { NotificationCenter } from "@/components/renewal/NotificationCenter";
import "@/components/layout/topbar.css";

type TopBarProps = {
  onOpenMenu: () => void;
  menuOpen: boolean;
  /** AppShell's ref to the hamburger — refocused when the drawer closes. */
  menuButtonRef?: Ref<HTMLButtonElement>;
};

/**
 * Mobile-only (<lg) sticky top bar — gradient-kissed surface (bg-2 whisper at
 * the top edge + 1px inner highlight) over the flat canvas, hairline bottom
 * border. Hamburger + wordmark only; nav + profile live in the slide-in
 * drawer. On lg+ the bar doesn't render at all — wordmark, nav and profile
 * belong to the fixed sidebar and the slim content bar (AppShell).
 * Game-HUD 방향 전환: 잔액·무료팩 칩은 compact HudChips로 상시 노출한다
 * (웹게임 헤더 문법 — 구 "잔액 비노출" 원칙은 폐기).
 */
export function TopBar({ onOpenMenu, menuOpen, menuButtonRef }: TopBarProps) {
  return (
    <header className="ty-topbar sticky top-0 z-40 border-b border-line lg:hidden">
      <div className="mx-auto flex h-14 max-w-6xl items-center gap-3 px-4 sm:px-6">
        <button
          ref={menuButtonRef}
          type="button"
          onClick={onOpenMenu}
          aria-label="Open menu"
          aria-expanded={menuOpen}
          className="grid size-11 shrink-0 place-items-center rounded-full border border-line bg-white/4 text-ink-dim outline-none transition-colors duration-200 hover:border-line-hi hover:text-ink focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-accent/60"
        >
          <BasilMenu className="size-4.5" aria-hidden />
        </button>

        <BrandWordmark withTick />

        <div className="ml-auto flex items-center gap-1.5">
          <HudChips compact />
          <NotificationCenter />
        </div>
      </div>
    </header>
  );
}
